import { useCallback } from 'react';
import { Platform } from 'react-native';

export const useScrollLock = () => {
  const lockScroll = useCallback(() => {
    if (Platform.OS === 'web') {
      // TODO: implement it
    }
  }, []);

  const unlockScroll = useCallback(() => {
    // Reverts to the default/previous state, often an empty string
    if (Platform.OS === 'web') {
      // TODO: implement it
    }
  }, []);

  return { lockScroll, unlockScroll };
};
